var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M9,8 L9,11 L11,11 L8,14 L5,11 L7,11 L7,8 L9,8 Z M8,2 C10.5507375,2 13.1014783,3.17537357 15.6522192,5.5261207 C16.085071,5.92502189 16.1184241,6.60574625 15.7267216,7.04655429 L14.1200448,8.68467777 C13.7072612,9.10505456 13.0380068,9.10505456 12.6252232,8.68467777 L11,7 L11,5 L10.7508089,4.75099351 C10.1948654,4.21619101 9.75,4 8,4 L7.53429049,4.00597122 C5.94793503,4.0500846 5.64594349,4.34217428 5,5 L5,7 L3.45273639,8.59596631 C3.08806183,9.06019481 2.42290077,9.13546113 1.96705758,8.76407832 L1.8799485,8.68467777 L0.309601788,7.08544429 C-0.0714448825,6.69740878 -0.100756165,6.08680925 0.221659332,5.66452436 L0.347767636,5.52612667 C2.89851063,3.17537556 5.44925363,2 8,2 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/EndCall.a151f124.svg";
export { ForwardRef as ReactComponent };